
export default {
  element: 'details',
  mutate: function mutate(element) {
    element.innerHTML = '<summary>foo</summary><p>content</p>';
    return element.firstElementChild;
  }
};
//# sourceMappingURL=focus-summary.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-summary.js
// module id = 198
// module chunks = 0 1